//公用获取初始化列表 方法  
// 转参 路径  sendData={page：1，pageSize：20}
export function CAFGetList(sendUrl = "", sendData = {}) {
	const that = this;
	sendData.pageSize = 20;
	return that.axiosGet(sendUrl, sendData).then((response) => {
		that.loading2 = false;
		if (parseInt(response.data.state) == 0) {
			that.$message({
				message: '查询成功',
				type: 'success'
			});
			return response.data;
			//数组赋值
			that.tableData = response.data.result;
			that.total = parseInt(response.data.count);
		} else {
			that.$message({
				message: response.data.message,
				type: 'warning'
			});
		}
	})
}

//公用添加 方法  
// 转参 路径  sendData={page：1，pageSize：20}  注意 dialogVisibleAdd 赋值问题
export function CAFSubmit(sendUrl = "", sendData = {}, sendGetlistUrl = "") {
	const that = this;
	that.axiosPost(sendUrl, sendData, sendGetlistUrl).then((response) => {
		if (parseInt(response.data.state) == 0) {
			this.$message({
				message: '操作成功！',
				type: 'success',
				onClose: () => {
					this.dialogVisibleAdd = false;
					this.dialogVisible = false;
					this.CAFGetList(sendGetlistUrl, {
						page: 1
					});
				}
			});
		} else {
			this.dialogVisibleAdd = false;
			this.dialogVisible = false;
			this.$message({
				message: "操作失败！",
				type: 'warning'
			});
		}
	})
}

//公用删除 方法  
// 转参 路径  sendData={page：1，pageSize：20}
export function CAFDelete(sendUrl = "", sendData = {}, sendGetlistUrl = "") {
	this.$confirm('确认删除?', '提示', {
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning'
	}).then(() => {
		// 删除 请求
		this.axiosGet(sendUrl, sendData).then((response) => {
			if (parseInt(response.data.state) == 0) {
				this.$message({
					message: '删除成功！',
					type: 'success',
					onClose: () => {
						this.CAFGetList(sendGetlistUrl, {
							page: 1
						});
					}
				});
			} else {
				this.$message({
					message: "删除失败！",
					type: 'warning'
				});
			}
		})
	}).catch(() => {
		this.$message({
			type: 'info',
			message: '已取消'
		});
	});
}



// WEBPACK FOOTER //
// ./src/public/CommonAjaxFun.js